import {configParamsModule} from "../../configParamsModule";
import {IHttpService, IPromise} from "angular";
import userManagementServer from "../../../userManagementServer";
import server from "../../../server";
import {OptimizationConfiguration} from "../../model/optimizationConfiguration";
import {IntegrationConfiguration} from "../../model/integrationConfiguration";

export class PermissionGroupSupportService {
    constructor(private $http: IHttpService) {
    }

    getAuthenticated(): IPromise<any> {
        return this.$http.get(userManagementServer.getServiceUrl("permission-group-authenticated"))
            .then((response: any) => {
                return response.data
            });
    }

    purgeProgrammingDatabase() {
        return this.$http.post<void>(server.getServiceUrl("purge-programming-database"), {})
            .then(response => response.data)
    }

    purgeExecutionDatabase() {
        return this.$http.post<void>(server.getServiceUrl("purge-execution-database"), {})
            .then(response => response.data)
    }

    getBiConfigurations() {
        return this.$http.get<any>(server.getServiceUrl("microstrategy-configuration")).then(response => response.data);
    }

    saveBiConfigurations(configurations) {
        return this.$http.post<void>(server.getServiceUrl("microstrategy-configuration"), configurations).then(response => response.data);
    }

    isBiAllowed() {
        return this.$http.get<boolean>(server.getServiceUrl("microstrategy-is-allowed")).then(response => response.data);
    }

    getUsers() {
        return this.$http.post<any>(server.getServiceUrl("r2-all-users-restricted"), null).then(response => response.data);
    }

    findOptimizationConfigurations() {
        return this.$http.get<OptimizationConfiguration>(server.getServiceUrl("optimization-configuration-find"), {})
            .then(response => response.data)
    }

    findIntegrationConfigurations() {
        return this.$http.get<IntegrationConfiguration>(server.getServiceUrl("integration-configuration-find"), {})
            .then(response => response.data)
    }

    saveOptimizationConfigurations(optimizationConfiguration: OptimizationConfiguration) {
        return this.$http.post<void>(server.getServiceUrl("optimization-configuration-save"), optimizationConfiguration)
            .then(response => response.data)
    }

    saveIntegrationConfigurations(integrationConfiguration: IntegrationConfiguration) {
        return this.$http.post<void>(server.getServiceUrl("integration-configuration-save"), integrationConfiguration)
            .then(response => response.data)
    }

    getExternalFreightConfigurations() {
        return this.$http.get<any>(server.getServiceUrl("external-freight-configuration")).then(response => response.data);
    }

    saveExternalFreightConfigurations(configurations) {
        return this.$http.post<void>(server.getServiceUrl("external-freight-configuration"), configurations).then(response => response.data);
    }

    retrieveGeocodificationProviders() {
        return this.$http.get<string[]>(server.getServiceUrl("retrieve-providers") )
            .then(response => response.data)
    }

    getGeocodificationProviderByPermissionGroup() {
        return this.$http.get<string>(server.getServiceUrl("retrieve-provider-by-permission-group") )
            .then(response => response.data)
    }
    saveGeocodificationProviderConfiguration(geocodificationProvider) {
        return this.$http.post<void>(server.getServiceUrl("save-geocodification-providers-configuration"), geocodificationProvider)
            .then(response => response.data);
    }

}

configParamsModule.service("permissionGroupSupportService", PermissionGroupSupportService)